export const SWITCH_THEME = "SWITCH_THEME";
export const TOGGLE_THEME = "TOGGLE_THEME";
